import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const ComisiaDeInventar: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Comisia de Inventar
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Responsabil: Gheorghe Semeniuc
          </Typography>
          <Typography variant="body1">
            Comisia de Inventar se ocupă de inventarierea și 
            evidența bunurilor eparhiei.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ComisiaDeInventar;
